import React, {useState} from "react";
import {Box, Typography, Button, FormLabel, FormControl, TextField, FormHelperText} from "@mui/material";
import {ErrorMessage, FormikProvider, useFormik} from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {getEndPoint} from "../../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors} from "../../../helpers/errorHandling";
import {PAGE_APPLICATIONS} from "../../../locales/pages/namespaces";
import {getRouteUrl} from "../../../helpers/routing/getRouteUrl";
import {ROUTE_PAGE_HOME} from "../../../routers/routes";
import {useUser} from "../../../userContext/userContext";
import PasswordInput from "../../mui/form/passwordInput/passwordInput";
import {Home} from "@mui/icons-material";
import {LoadingButton} from "@mui/lab";




const validationSchema = Yup.object({
    currentPassword: Yup.string().required("Required"),

    newPassword: Yup.string()
        .required("Required")
        .min(8, "At least 8 characters")
        .max(30, "Up to 30 characters")
        .matches(/[a-z]/, "At least one lowercase letter")
        .matches(/[A-Z]/, "At least one uppercase letter")
        .matches(/[0-9]/, "At least one number")
        .matches(/[^a-zA-Z0-9]/, "At least one special character"),

    repeatNewPassword: Yup.string()
        .oneOf([Yup.ref("newPassword")], "At least one special character")
        .required("Required"),
});

const Form = ({ email }) => {
    const history = useHistory();
    const { campaign } = useParams();
    const {changePassId,changePassMail} = useUser()
    const { t } = useTranslation(PAGE_APPLICATIONS);
    const [loading,setLoading] = useState(false)

    const whiteInputStyles = {
        variant: "standard",
        InputProps: {
            disableUnderline: true,
            sx: {
                borderBottom: "1px solid rgba(255,255,255,0.8)",
                pb: 0.5,


                "& .MuiInputBase-input": {
                    color: "#fff !important",
                },

                "& .MuiInputBase-input::placeholder": {
                    color: "rgba(255,255,255,0.6) !important",
                },

                "& .MuiInputBase-root": {
                    color: "#fff !important",
                },
                "& .MuiInputAdornment-root svg": {
                    display: "none",
                },
                // "& svg": {
                // 	color: "#fff !important",
                // },

                "&:hover": {
                    borderBottom: "1px solid #fff",
                }
            }
        }
    };
    function onSubmit(values) {
        setLoading(true)
        const payload = {
            id:changePassId,
            initialpassword: values.currentPassword,
            newpassword: values.newPassword,
        };

        axios({
            method: "post",
            url: getEndPoint("initialChangePassword"),
            data: payload,
            headers: { "Content-Type": "application/json" },
        })
            .then((message) => {
                if(message.data.message == 'UNABLE to change Initial Password'){
                    enqueueSnackbar(
                        t("Unable to change password!"),
                        { variant: "warning" },
                    );
                }else{
                    enqueueSnackbar(
                        t("Password changed successfully"),
                        { variant: "success" }
                    );
                    history.push(getRouteUrl(ROUTE_PAGE_HOME, { campaign }));
                }
                setLoading(false)
            })
            .catch((error) => {
                setLoading(false)
                enqueueSnackbar(t("Failed change password"), {
                    variant: "error",
                });
            });
    }
    const formik = useFormik({
        initialValues: {
            email:  changePassMail,
            currentPassword: "",
            newPassword: "",
            repeatNewPassword: "",
        },
        validationSchema,
        onSubmit:onSubmit,
    });

    return (
        <FormikProvider value={formik}>
            <Box
                maxWidth={420}
                mx="auto"
                mt={6}
                display="flex"
                flexDirection="column"
                gap={2}
            >
                {/* Email */}
                <FormControl fullWidth sx={{ mb: 3 }}>
                    <FormLabel sx={{ color: "#fff", fontSize: 14, mb: 1 }}>
                        {t("Email")}
                    </FormLabel>
                    <TextField
                        {...whiteInputStyles}
                        name="email"
                        value={formik.values.email}
                        disabled
                        onBlur={formik.handleBlur}
                        required
                    />
                    <FormHelperText sx={{ color: "#ffd1d1" }}>
                        <ErrorMessage name="email" />
                    </FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                    <FormLabel sx={{ color: "#fff", fontSize: 14, mb: 1 }}>
                        {t("Password")}
                    </FormLabel>
                    <PasswordInput
                        formik={formik}
                        name="currentPassword"
                        label={t("Password")}
                        value={formik.values.currentPassword}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        required
                        otherProps={{
                            ...whiteInputStyles,

                        }}
                    />
                    <FormHelperText sx={{ color: "#ffd1d1" }}>
                        <ErrorMessage name="currentPassword" />
                    </FormHelperText>
                </FormControl>

                <Typography sx={{ fontSize: 13, color: "#fff", mt: 1 }}>
                    {t('Your password must contain at least 8 characters and include at least one lowercase letter, one uppercase letter, one number, and one special character.')}
                </Typography>
                <FormControl fullWidth>
                    <FormLabel sx={{ color: "#fff", fontSize: 14, mb: 1 }}>
                        {t("New Password")}
                    </FormLabel>

                    <PasswordInput
                        formik={formik}
                        name="newPassword"
                        label={t("New Password")}
                        value={formik.values.newPassword}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        required
                        otherProps={{
                            ...whiteInputStyles,

                        }}
                    />
                    <FormHelperText sx={{ color: "#ffd1d1" }}>
                        <ErrorMessage name="newPassword" />
                    </FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                    <FormLabel sx={{ color: "#fff", fontSize: 14, mb: 1 }}>
                        {t("Repeat New Password")}
                    </FormLabel>

                    <PasswordInput
                        formik={formik}
                        name="repeatNewPassword"
                        label={t("Repeat New Password")}
                        value={formik.values.repeatNewPassword}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        required
                        otherProps={{
                            ...whiteInputStyles,
                        }}
                    />
                    <FormHelperText sx={{ color: "#ffd1d1" }}>
                        <ErrorMessage name="repeatNewPassword" />
                    </FormHelperText>
                </FormControl>

                <Box mt={3}>
                    <LoadingButton
                        loading={loading}
                        sx={{
                            mt: 4,
                            py: 1.4,
                            background: "#FFFFFF",
                            color: "#004B88",
                            fontWeight: 700,
                            borderRadius: "3px",
                            textTransform: "none",
                            "&:hover": {
                                background: "#e6e6e6"
                            }
                        }}
                        fullWidth
                        variant="contained"
                        disabled={!formik.isValid || !formik.dirty}
                        onClick={formik.handleSubmit}
                    >
                        {t("Continue")}
                    </LoadingButton>

                    <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<Home />}
                        sx={{
                            mt: 2,
                            py: 1.4,
                            textTransform: "none",
                            borderColor: "rgba(255,255,255,0.7)",
                            color: "#fff",
                            "&:hover": {
                                borderColor: "#fff",
                                background: "rgba(255,255,255,0.1)",
                            },
                        }}
                        onClick={() => history.push(getRouteUrl(ROUTE_PAGE_HOME,{campaign}))}
                    >
                        {t("Home")}
                    </Button>
                </Box>
            </Box>
        </FormikProvider>
    );
};

export default Form;
